import { useState, useEffect } from 'react';

import FormControl from '@mui/material/FormControl';
import Multiselect from '../../../../../../../components/UI/Input/Multiselect/Multiselect';
import { MultiselectTypes } from '../../../../../../../components/UI/Input/Multiselect/_types';
import { Headline6 } from '../../../../../../../components/UI/MDC/Typography/Typography';

const SubgroupMultiSelect = ({ handleChange, selectedOptions, options }) => {
	const [optionsList, setOptionsList] = useState([]);

	useEffect(() => {
		if (options?.length > 0) {
			setOptionsList(
				options.map(o => {
					return {
						value: o.SubGroupName,
						isSelected: selectedOptions.includes(o.SubGroupName),
						isDisplayed: true,
					};
				})
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options]);

	const label = 'SubGroups';

	return (
		<div>
			{options?.length > 0 ? (
				<>
					<Headline6>Subgroups</Headline6>
					<FormControl variant='filled' fullWidth>
						<Multiselect
							name='subgroups'
							options={optionsList}
							actionTitle={label}
							settings={{
								type: MultiselectTypes.LIST,
								selectHandler: e => {
									const newOptions = [...optionsList];
									newOptions[e].isSelected =
										!newOptions[e].isSelected;
									setOptionsList(newOptions);
									handleChange(newOptions);
								},
								chipHandler: e => {
									const newOptions = [...optionsList];
									const index = newOptions.findIndex(
										o => o.value === e.value
									);
									if (index > -1) {
										newOptions[index].isSelected = false;
										setOptionsList(newOptions);
									}
								},
							}}
						/>
					</FormControl>
				</>
			) : null}
		</div>
	);
};

export default SubgroupMultiSelect;
